import * as tslib_1 from "tslib";
import { Component, Vue, Ref } from "vue-property-decorator";
import { scrollTop } from "@/utils/scroll-to";
import draggable from 'vuedraggable';
import { getCourseContent, getCourseInfo, searchMediaList, getProductInfo, uploadCourseCover, getSeminarInfo, saveChapter, deleteChapter, updateMediaSort, updateChapterMediaSort, deleteMediaContent, addMediaContent, saveCourseContent } from "@/api/course";
import { checkSession } from '@/api/commom';
import { UserModule } from "@/store/modules/user";
import WangEditor from "@/components/WangEditor/index.vue";
import { Debounce } from "@/decorators";
import eventEmitter from '@/utils/eventEmitter';
const tabsMap = ["", "profile", "content"];
const mediaTypeMap = ["", "音频", "视频", "图文", "考试"];
const mediaStatusMap = ["未上架", "已上架"];
// 根据后端要求 本地拼接商品详情页路由 并传给后端
const courseDetailRouter = {
    1: '/details',
    3: '/graphic/details',
    4: '/activity/details',
    9: '/team/details',
    10: '/combined/details',
};
let timer = null;
let CourseEdit = class CourseEdit extends Vue {
    constructor() {
        super(...arguments);
        this.currentTab = "profile";
        this.courseData = {
            id: "",
            name: "",
            type: 1,
            cover: "",
            description: "",
            totalCount: 0,
            updatedCount: 0,
            details: "",
            productList: [],
            isChapterEnabled: 0,
            productId: "",
            seminarId: "",
            courseDataUpdateOrder: 2,
        };
        this.isCoverLoading = false; // 课程封面加载状态
        this.isProductAdd = false; // 精选推荐添加状态
        this.productIdToAdd = ""; // 推荐课程对应的商品ID
        this.chooseType = 1; // 1音频 2视频 3图文
        // v5.7.10 改用chapterList
        // private courseContentList: IMedia[] = []; // 当前课程的课程内容 
        this.isCourseContentLoading = false; // 课程内容加载状态
        // 课程内容选择器
        this.mediaViewer = {
            isVisible: false,
            isLoading: false,
            keyword: "",
            _keyword: "",
            mediaList: [],
            selectedList: [],
        };
        // 课程内容列表分页器
        this.mediaPaginator = {
            pageNo: 1,
            pageSize: 15,
            total: 0,
        };
        this.productIdState = {
            isError: false,
            message: ''
        };
        this.seminarIdState = {
            isError: false,
            message: ''
        };
        this.chapterList = []; // 当前课程的章节列表
        this.chapterEditor = {
            isEdit: false,
            chapter: {
                id: '',
                name: ''
            }
        };
        this.isPrevent = false;
        this.onProductIdChange = this._onProductIdChange();
        this.onSeminarIdChange = this._onSeminarIdChange();
    }
    created() {
        const query = this.$route.query;
        // 传入ID则判定为编辑 未传入则为新增
        if (query.id) {
            this.courseData.id = query.id;
            if (query.step) {
                this.currentTab = tabsMap[Number(query.step)];
            }
            this.getCourseData();
            this.getContentList();
        }
        eventEmitter.on('routerRapture', () => {
            return this.isPrevent ? Promise.resolve() : Promise.reject();
        });
        const t = 1 * 60 * 1000;
        timer = setInterval(() => {
            this.checkHeartbeat();
        }, t);
    }
    beforeDestroy() {
        clearInterval(timer);
    }
    async checkHeartbeat() {
        await checkSession();
    }
    _onProductIdChange() {
        let _id = '';
        return async () => {
            const id = this.courseData.productId;
            if (id === _id)
                return;
            _id = id;
            this.courseData.productUrl = '';
            if (!id || !Number(id)) {
                this.productIdState = {
                    isError: false,
                    message: ''
                };
                return;
            }
            try {
                const { data } = await getProductInfo(id, 2);
                if (data.status !== 200)
                    throw new Error('');
                this.productIdState = {
                    isError: false,
                    message: data.data.name
                };
                const productType = data.data.type;
                this.courseData.productUrl = `${courseDetailRouter[productType]}?id=${id}`;
            }
            catch (error) {
                this.productIdState = {
                    isError: true,
                    message: '输入的商品ID有误，无匹配商品'
                };
            }
        };
    }
    _onSeminarIdChange() {
        let _id = '';
        return async () => {
            const id = this.courseData.seminarId;
            if (id === _id)
                return;
            _id = id;
            if (!id || !Number(id)) {
                this.seminarIdState = {
                    isError: false,
                    message: ''
                };
                return;
            }
            try {
                const { data } = await getSeminarInfo(id);
                if (data.status !== 200)
                    throw new Error('');
                this.seminarIdState = {
                    isError: false,
                    message: data.data.name
                };
            }
            catch (error) {
                this.seminarIdState = {
                    isError: true,
                    message: '输入的专题ID有误，无匹配专题'
                };
            }
        };
    }
    handleTabChange(tab) {
        // if (this.currentTab === "profile") {
        //   this.getCourseData();
        // } else if (this.currentTab === "content") {
        //   this.getContentList();
        // }
        // this.$confirm("离开将不保存本页修改", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "warning",
        // })
        //   .then(() => {
        //     // 你可以在这儿做些操作
        //   })
        //   .catch((err) => {});
    }
    // 获取课程数据
    async getCourseData() {
        const res = await getCourseInfo(this.courseData.id);
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return;
        this.courseData = {
            id: data.id,
            name: data.name,
            cover: data.picUrl,
            type: data.type,
            description: data.description,
            totalCount: data.totalPeriod,
            updatedCount: data.updatePeriod,
            details: data.content,
            courseDataUpdateOrder: data.courseDataUpdateOrder,
            productList: data.productList.map((product) => {
                return {
                    id: String(product.id),
                    image: product.image,
                    title: product.name,
                };
            }),
            isChapterEnabled: data.isOpenChapter || 0,
            productId: data.productId || '',
            seminarId: data.seminarId || '',
        };
        if (data.type !== 3) {
            this.chooseType = data.type;
        }
        if (data.content) {
            this.wangEditor.setContent(data.content);
        }
        if (data.productId) {
            this.onProductIdChange();
        }
        if (data.seminarId) {
            this.onSeminarIdChange();
        }
    }
    // 选择课程封面
    handleCoverSelect(file) {
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            this.$message.error("封面图片大小不能超过 5MB!");
            return false;
        }
        const isJPG = file.type === "image/jpg" || file.type === "image/jpeg";
        const isPNG = file.type === "image/png";
        if (!(isJPG || isPNG)) {
            this.$message.error("封面图片只能是JPG/PNG格式!");
            return false;
        }
        return true;
    }
    // 上传课程封面
    async handleCoverUpload(data) {
        this.isCoverLoading = true;
        const file = data.file;
        try {
            const res = await uploadCourseCover(file, {
                token: UserModule.token,
                ssoId: UserModule.ssoId,
            });
            // 防止奇奇怪怪的人卡bug, 重置状态后再取消禁用上传
            this.$nextTick(() => {
                this.isCoverLoading = false;
            });
            if (res.data.status !== 200) {
                // 上传器公用 随手清理垃圾
                return this._coverUploader.clearFiles();
            }
            this.courseData.cover = res.data.data;
        }
        catch {
            this.isCoverLoading = false;
        }
    }
    // 添加精选推荐
    async hanldeProductAdd() {
        const id = this.productIdToAdd;
        const pList = this.courseData.productList;
        if (id == "") {
            return this.$message.error("请输入推荐课程的商品ID");
        }
        if (pList.length >= 5) {
            return this.$message.error("最多只能添加5个推荐课程");
        }
        // 校验列表中是否有重复的
        if (pList.some((product) => product.id == id)) {
            return this.$message.error("列表中已有该课程");
        }
        // 获取推荐课程的信息
        const res = await getProductInfo(id);
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return this.$message.error("该ID没有对应的商品");
        this.courseData.productList.push({
            id: data.id,
            image: data.image,
            title: data.name,
        });
        this.productIdToAdd = "";
        this.isProductAdd = false;
    }
    // 删除精选推荐
    handleProductDelete(idx) {
        this.courseData.productList.splice(idx, 1);
    }
    // 保存课程数据
    async saveCourseData() {
        const course = this.courseData;
        if (course.cover === "") {
            return this.$message.error("请上传封面图");
        }
        if (course.name === "") {
            return this.$message.error("课程名称不能为空");
        }
        if (course.description === "") {
            return this.$message.error("课程简介不能为空");
        }
        if (course.details === "") {
            return this.$message.error("课程详情不能为空");
        }
        if (course.totalCount <= 0) {
            return this.$message.error("课程期数输入有误,请输入大于0的正整数！");
        }
        const data = {
            id: course.id,
            name: course.name,
            picUrl: course.cover,
            description: course.description,
            totalPeriod: String(course.totalCount),
            content: course.details,
            productIds: course.productList
                .map(p => p.id)
                .join(","),
            isOpenChapter: course.isChapterEnabled,
            productId: course.productId,
            seminarId: course.seminarId,
            type: course.type,
            productUrl: course.productUrl,
            courseDataUpdateOrder: course.courseDataUpdateOrder
        };
        const res = await saveCourseContent(data);
        if (res.data.status === 200) {
            this.$message.success("保存成功");
            const id = String(res.data.data);
            // 保存成功后自动切换tab
            if (id) {
                this.courseData.id = id;
                this.chooseType = this.courseData.type;
                this.currentTab = "content";
            }
        }
    }
    // 获取课程内容
    async getContentList() {
        this.isCourseContentLoading = true;
        const res = await getCourseContent(this.courseData.id);
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return;
        // [FEATURE] 5.7.10
        this.chapterList = data.map((chapter) => ({
            id: chapter.id,
            name: chapter.name,
            mediaList: chapter.contentList && chapter.contentList.map((media) => ({
                id: media.id,
                name: media.title,
                type: mediaTypeMap[media.type] || "-",
                typeVal: media.type,
                size: media.mediaSize || "-",
                status: mediaStatusMap[media.contentStatus] || "-",
                addTime: media.delayedTime,
                mediaId: media.mediaId
            })) || []
        }));
        this.isCourseContentLoading = false;
    }
    onJumpPage(props) {
        console.log(props);
        if (props.typeVal == 1) {
            this.$router.push({
                path: '/data-manager/audio/edit',
                query: {
                    id: props.mediaId
                }
            });
        }
        else if (props.typeVal == 2) {
            this.$router.push({
                path: '/data-manager/video/edit',
                query: {
                    id: props.mediaId
                }
            });
        }
        else if (props.typeVal == 3) {
            this.$router.push({
                path: '/data-manager/graphic/edit',
                query: {
                    id: props.mediaId
                }
            });
        }
    }
    // 删除课程内容
    async handleContentDelete(idx, pidx) {
        const _media = this.chapterList[pidx].mediaList[idx];
        try {
            await this.$confirm(`是否确认删除 “${_media.name}”`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            });
        }
        catch (error) {
            return;
        }
        try {
            const query = {
                courseDataIds: _media.id,
            };
            const res = await deleteMediaContent(query);
            if (res.data.status !== 200)
                return;
            this.chapterList[pidx].mediaList.splice(idx, 1);
            this.getCourseData();
            this.$message.success("删除成功");
        }
        catch (error) { }
    }
    // 排序课程内容
    async handleContentSort(pidx) {
        // const query: Record<string, any> = {
        //   chapterId: this.chapterList[pidx].id,
        //   mediaIds: this.chapterList[pidx].mediaList.map((media) => media.id).join(","),
        // };
        console.log(this.chapterList);
        const mediaIds = this.chapterList[pidx].mediaList.map((media) => media.id).join(",");
        try {
            const res = this.courseData.isChapterEnabled === 1 ? await updateChapterMediaSort({
                chapterId: this.chapterList[pidx].id,
                courseDataIds: mediaIds,
            }) : await updateMediaSort({
                courseId: this.courseData.id,
                courseDataIds: mediaIds,
            });
            if (res.data.status !== 200)
                throw new Error("排序失败");
            this.$message({
                type: 'success',
                message: '更新成功'
            });
        }
        catch (error) {
            // 复原排序
            this.getContentList();
            // this.$message.error('排序保存失败');
        }
    }
    handleClickType(tabs) {
        this.chooseType = tabs.name;
        this.mediaPaginator.pageNo = 1;
        this.getMediaList();
    }
    // 新增课程内容弹窗
    showMediaViewer(chapterId) {
        if (this.chapterEditor.isEdit) {
            this.$message.error("请先完成当前编辑");
            return;
        }
        this.mediaPaginator = {
            pageNo: 1,
            pageSize: 15,
            total: 0,
        };
        this.mediaViewer = {
            isVisible: true,
            isLoading: true,
            keyword: "",
            _keyword: "",
            mediaList: [],
            selectedList: [],
            chapterId,
        };
        this.getMediaList();
    }
    // 获取课程内容列表（弹窗）
    async getMediaList() {
        const res = await searchMediaList({
            searchName: this.mediaViewer._keyword,
            pageNo: this.mediaPaginator.pageNo,
            pageSize: this.mediaPaginator.pageSize,
            type: this.courseData.type == 3 ? this.chooseType : this.courseData.type,
            courseId: this.courseData.id,
        });
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        if (!data)
            return;
        this.mediaViewer.mediaList = data.list.map((media) => {
            return {
                id: String(media.id),
                name: media.title,
                image: media.fileUrl,
                mediaId: media.mediaId
            };
        });
        this.mediaViewer.isLoading = false;
        this.mediaPaginator.total = Number(data.total);
    }
    // 搜索课程内容列表（弹窗）
    handleMediaFilter() {
        this.mediaViewer._keyword = this.mediaViewer.keyword;
        this.mediaPaginator.pageNo = 1;
        this.getMediaList();
    }
    // 课程内容列表换页（弹窗）
    async handleMediaPageChange(pageNo) {
        this.mediaPaginator.pageNo = pageNo;
        // 获取弹窗中表格dom
        const el = document.getElementById("audio-table").getElementsByClassName("el-table__body-wrapper")[0];
        // 表格滚动置顶后再刷新数据
        scrollTop(el, 0, 233, this.getMediaList);
    }
    // 选中课程内容（弹窗）
    handleMediaSelect(selection) {
        this.mediaViewer.selectedList = selection;
    }
    // 新增课程内容
    async handleContentAdd() {
        const query = {
            courseId: this.courseData.id,
            mediaIds: this.mediaViewer.selectedList
                .map((media) => media.id)
                .join(","),
            courseDataType: this.chooseType,
            chapterId: this.mediaViewer.chapterId,
        };
        try {
            const res = await addMediaContent(query);
            if (res.data.status !== 200)
                return;
            this.$message.success("添加成功");
            this.mediaViewer.isVisible = false;
            this.getContentList();
            this.getCourseData();
        }
        catch (error) { }
    }
    // 关闭章节名编辑
    closeChapterEditor() {
        this.chapterEditor = {
            isEdit: false,
            chapter: {
                id: "",
                name: "",
            },
        };
    }
    // 新增章节
    handleChapterAdd() {
        if (this.chapterEditor.isEdit) {
            this.$message.error("请先完成当前编辑");
            return;
        }
        this.chapterList.push({
            id: '-1',
            name: '',
            mediaList: [],
        });
        this.handleChapterEdit(this.chapterList.length - 1);
    }
    // 编辑章节
    handleChapterEdit(idx) {
        const _chapter = this.chapterList[idx];
        this.chapterEditor = {
            isEdit: true,
            chapter: {
                id: _chapter.id,
                name: _chapter.name,
            },
        };
    }
    handleChapterCancel(idx) {
        if (this.chapterList[idx].id != '-1') {
            this.chapterEditor.isEdit = false;
        }
        else {
            this.chapterEditor.isEdit = false;
            this.chapterList.splice(idx, 1);
        }
    }
    // 确认章节修改
    async handleChapterSave(idx) {
        const _chapter = this.chapterEditor.chapter;
        if (_chapter.name.trim() === "") {
            this.$message.error("请输入章节名称");
            return;
        }
        if (_chapter.name === this.chapterList[idx].name) {
            this.chapterEditor.isEdit = false;
            return;
        }
        if (this.chapterList.some(chapter => chapter.name === _chapter.name)) {
            this.$message.error("章节名称重复");
            return;
        }
        try {
            const { data } = await saveChapter({
                courseId: this.courseData.id,
                chapterId: _chapter.id === '-1' ? undefined : _chapter.id,
                chapterName: _chapter.name,
            });
            if (data.status !== 200)
                return;
            this.chapterList[idx].name = _chapter.name;
            this.chapterList[idx].id = data.data;
            this.closeChapterEditor();
        }
        catch (error) { }
    }
    // 删除章节
    async handleChapterDelete(idx) {
        if (this.chapterEditor.isEdit) {
            if (this.chapterEditor.chapter.id !== this.chapterList[idx].id) {
                this.$message.error("请先完成当前编辑");
                return;
            }
            this.chapterList.splice(idx, 1);
            this.closeChapterEditor();
        }
        else {
            try {
                await this.$confirm(`是否删除章节 “${this.chapterList[idx].name}”`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                });
            }
            catch (error) {
                return;
            }
            try {
                const { data } = await deleteChapter(this.chapterList[idx].id);
                if (data.status !== 200)
                    return;
                this.chapterList.splice(idx, 1);
            }
            catch (error) { }
        }
    }
};
tslib_1.__decorate([
    Ref()
], CourseEdit.prototype, "_coverUploader", void 0);
tslib_1.__decorate([
    Ref()
], CourseEdit.prototype, "_audioTable", void 0);
tslib_1.__decorate([
    Ref()
], CourseEdit.prototype, "wangEditor", void 0);
tslib_1.__decorate([
    Debounce(300)
], CourseEdit.prototype, "handleContentSort", null);
CourseEdit = tslib_1.__decorate([
    Component({
        name: "CourseEdit",
        components: {
            WangEditor,
            draggable
        },
    })
], CourseEdit);
export default CourseEdit;
